module.exports = __webpack_public_path__ + "static/img/yidong.9035ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yidong.jpg
// module id = 1Zok
// module chunks = 0